import type { LabelHTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

interface FieldLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  /** Adds the red asterisk. It is hidden from screen readers; the field's `required` says it. */
  required?: boolean;
}

export function FieldLabel({ required, className, children, ...rest }: FieldLabelProps) {
  return (
    <label className={cn('text-sm text-ink', className)} {...rest}>
      {children}
      {required && (
        <span aria-hidden className="text-danger">
          {' *'}
        </span>
      )}
    </label>
  );
}
